import React, { Component } from 'react';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { Provider, connect } from 'react-redux';
import saga from '../../sagas/circle/new';
import Module from '../../modules/circle/new';
// import FormPage1 from './form_page_1'; 2025/3/18廃止
// import FormOshikatsuCirclesPage from './form_oshikatsu_circles_page'; 2025/3/18廃止
import FormPage2 from './form_page_2';
import FormPage3 from './form_page_3';

const sagaMiddleware = createSagaMiddleware();
const store = createStore(Module.reducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(saga);

export default class CircleNew extends Component {
  render() {
    return (
      <Provider store={store}>
        <Root
          servicesCategories={this.props.servicesCategories}
          countriesPrefs={this.props.countriesPrefs}
          isDisableCreateCircle={this.props.isDisableCreateCircle}
          circle={this.props.circle}
          guideline={this.props.guideline}
          isApp={this.props.isApp}
          companyId={this.props.companyId}
          type={this.props.type}
          servicesCircles={this.props.servicesCircles}
          circlesRelations={this.props.circlesRelations}
          circleList={this.props.circleList}
          selectedGenres={this.props.selectedGenres}
        />
      </Provider>
    );
  }
}

class TmpRoot extends Component {
  constructor(props) {
    super(props);
    this.props.initialEditSet(
      {
        ...this.props.circle,
        main_image_url: this.props.circle.main_image_url_for_circle_edit,
      },
      this.props.servicesCategories,
      this.props.countriesPrefs,
      this.props.isDisableCreateCircle,
      this.props.circle.categories.map((item) => String(item.id)),
      this.props.selectedGenres || []
    );
    this.onChangeGenreKeyword = this.onChangeGenreKeyword.bind(this);
    this.onChangeMemberEventCreateEnable =
      this.onChangeMemberEventCreateEnable.bind(this);
  }
  /**
   * コンポーネントマウント時の処理
   */
  // UNSAFE_componentWillMount() {
  //   this.props.initialEditSet(
  //     {
  //       ...this.props.circle,
  //       main_image_url: this.props.circle.main_image_url_for_circle_edit,
  //     },
  //     this.props.servicesCategories,
  //     this.props.countriesPrefs,
  //     this.props.isDisableCreateCircle,
  //     this.props.selectedGenres
  //   );
  // }

  /**
   * 表示ページが変更された時の処理
   * @param {*} e
   */
  onChangeGenreKeyword(e) {
    this.props.changeGenreKeyword(e.target.value);
  }

  onChangeMemberEventCreateEnable(e) {
    this.props.changeMemberEventCreateEnable(e.target.value);
  }

  render() {
    let page;
    if (this.props.pageNum == '2') {
      page = <FormPage2 key={2} isApp={this.props.isApp}/>;
    } else if (this.props.pageNum == '3') {
      page = <FormPage3 key={3} isApp={this.props.isApp} companyId={this.props.companyId}/>;
    } else if (this.props.type === 'department' || this.props.type === 'circle') {
      page = <FormPage2 key={2} isApp={this.props.isApp} type={this.props.type} />;
    } else {
      page = (
        <FormPage2
          key={2}
          isApp={this.props.isApp}
        />
      );
    }
    return <div>{page}</div>;
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...state,
  servicesCategories: ownProps.servicesCategories,
  countriesPrefs: ownProps.countriesPrefs,
  isDisableCreateCircle: ownProps.isDisableCreateCircle,
  circle: ownProps.circle,
  guideline: ownProps.guideline,
  isApp: ownProps.isApp,
  type: ownProps.type,
  servicesCircles: ownProps.servicesCircles,
  circlesRelations: ownProps.circlesRelations,
  circleList: ownProps.circleList,
  selectedGenres: ownProps.selectedGenres,
});

const mapDispatchToProps = (dispatch) => {
  return {
    initialEditSet: (
      circle,
      servicesCategories,
      countriesPrefs,
      isDisableCreateCircle,
      selectedGenres
    ) => {
      dispatch(
        Module.actions.initialEditSet({
          circle,
          servicesCategories,
          countriesPrefs,
          isDisableCreateCircle,
          selectedGenres,
        })
      );
    },
  };
};

const Root = connect(mapStateToProps, mapDispatchToProps)(TmpRoot);
